var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select"},[_c('el-select',{model:{value:(_vm.params.province_id),callback:function ($$v) {_vm.$set(_vm.params, "province_id", $$v)},expression:"params.province_id"}},_vm._l((_vm.provinceList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.local_name,"value":item.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }